import React, { useState } from 'react'
import './BarChart.scss'
import { useWindowSize } from './useWindowSize'
let maxwidth = 0.95

export const BarChart = ({
  data,
  unit = '',
  title,
  sub,
  colorkey,
  source
}: {
  data: { name: string; values: number[] }[]
  unit?: string
  title?: string | JSX.Element
  sub?: string | JSX.Element
  source?: string | JSX.Element
  colorkey?: { name: string; color: string }[]
}) => {
  const defaultcolors = ['#000', '#444', '#888', '#aaa', '#ccc']
  const [showall, setShowall] = useState(false)
  const { width, height, isMobile } = useWindowSize()
  return (
    <div className='BarChart'>
      <div className='graphtitlewrapper'>
        {title && <div className='graphtitle'>{title}</div>}
        {sub && <div className='sub'>{sub}</div>}
      </div>
      {colorkey && (
        <div className='keywrapper'>
          {colorkey.map((color, k) => (
            <div className='keyentry' key={'bar' + k}>
              <div
                className='swatch'
                style={{ backgroundColor: color.color }}
              />
              {color.name}
            </div>
          ))}
        </div>
      )}
      <div className='bars'>
        {data.slice(0, showall ? data.length : 5).map((bar, k) => (
          <div className='bargroup' key={'bar2' + k}>
            <div className='bartitle'>{bar.name} </div>
            {bar.values.map((value, i) => (
              <Bar
                key={'bar3' + i}
                value={value}
                unit={unit}
                color={colorkey ? colorkey[i].color : defaultcolors[i]}
              />
            ))}
          </div>
        ))}
      </div>
      <div className='indicatemore' />
      <div className={'showmore ' + (isMobile ? 'mob' : '')}>
        <button
          onClick={() => {
            setShowall(!showall)
          }}
        >
          {showall ? (
            <>
              <b>–</b> Weniger anzeigen
            </>
          ) : (
            <>
              <b>+</b> Alle anzeigen
            </>
          )}
        </button>
      </div>
      {source && <div className='source'>Quelle: {source}</div>}
    </div>
  )
}

const Bar = ({
  value,
  unit = '',
  color
}: {
  value: number
  unit?: string
  color: string
}) => {
  return (
    <div className='barwrapper'>
      <div className='bar_bg' />
      <div
        className={'bar'}
        style={{ width: value * maxwidth + '%', backgroundColor: color }}
      />
      <div className='barlabel' style={{ left: value * maxwidth + '%' }}>
        <span>{value + unit}</span>
      </div>
    </div>
  )
}
